import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Lock, Wine, ArrowRight } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const ProposalAccess = () => {
  const navigate = useNavigate();
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await axios.post(`${BACKEND_URL}/api/proposal/validate`, {
        code: code.toUpperCase()
      });

      if (response.data.valid) {
        // Guardar código en sessionStorage
        sessionStorage.setItem('proposal_code', code.toUpperCase());
        navigate('/propuesta/view');
      } else {
        setError('Código inválido. Por favor verifica e intenta nuevamente.');
      }
    } catch (err) {
      setError('Código inválido. Por favor verifica e intenta nuevamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-black flex items-center justify-center p-4">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="max-w-md w-full"
      >
        {/* Logo y Header */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full mb-4"
               style={{background: 'linear-gradient(135deg, #D4AF37 0%, #C9A961 100%)'}}>
            <Wine className="h-10 w-10 text-white" />
          </div>
          <h1 className="text-3xl font-bold text-white mb-2">Bodega Spinoglio</h1>
          <p className="text-gray-400">Propuesta Comercial - Acceso Restringido</p>
        </div>

        {/* Card de Acceso */}
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.2, duration: 0.4 }}
          className="bg-white rounded-2xl shadow-2xl p-8"
        >
          <div className="flex items-center gap-3 mb-6">
            <div className="p-3 rounded-lg" style={{background: 'rgba(212, 175, 55, 0.1)'}}>
              <Lock className="h-6 w-6" style={{color: '#D4AF37'}} />
            </div>
            <div>
              <h2 className="text-xl font-bold text-gray-800">Acceso a Propuesta</h2>
              <p className="text-sm text-gray-600">Ingresa tu código de acceso</p>
            </div>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-gray-700 font-medium mb-2">
                Código de Acceso
              </label>
              <input
                type="text"
                value={code}
                onChange={(e) => setCode(e.target.value.toUpperCase())}
                placeholder="XXXXXX"
                maxLength={10}
                className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-transparent text-center text-2xl font-mono tracking-widest uppercase"
                style={{'--tw-ring-color': '#D4AF37'}}
                onFocus={(e) => e.target.style.boxShadow = '0 0 0 3px rgba(212, 175, 55, 0.3)'}
                onBlur={(e) => e.target.style.boxShadow = 'none'}
                required
              />
            </div>

            {error && (
              <motion.div
                initial={{ opacity: 0, y: -10 }}
                animate={{ opacity: 1, y: 0 }}
                className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg text-sm"
              >
                {error}
              </motion.div>
            )}

            <button
              type="submit"
              disabled={loading || code.length < 3}
              className="w-full flex items-center justify-center gap-2 px-6 py-4 text-white rounded-lg font-bold text-lg transition-all disabled:opacity-50 disabled:cursor-not-allowed hover:scale-105"
              style={{background: 'linear-gradient(135deg, #D4AF37 0%, #C9A961 100%)'}}
            >
              {loading ? (
                <>
                  <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" />
                  Validando...
                </>
              ) : (
                <>
                  Acceder a Propuesta
                  <ArrowRight className="h-5 w-5" />
                </>
              )}
            </button>
          </form>

          <div className="mt-6 pt-6 border-t border-gray-200 text-center">
            <p className="text-sm text-gray-600">
              ¿No tienes un código de acceso?
            </p>
            <p className="text-sm text-gray-500 mt-1">
              Contacta con nuestro equipo comercial
            </p>
          </div>
        </motion.div>

        {/* Footer */}
        <p className="text-center text-gray-500 text-sm mt-8">
          © 2025 Bodega Spinoglio. Todos los derechos reservados.
        </p>
      </motion.div>
    </div>
  );
};

export default ProposalAccess;
